import moment from 'moment-es6'

const DateFormat = {
  filters: {
    date (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    dateDay (value) {
      return moment(value).format('DD/MM/YYYY ddd.')
    },
    dayDate (value) {
      return moment(value).format('ddd, DD/MM/YYYY')
    },
    dayDateFull (value) {
      return moment(value).format('dddd, DD/MM/YYYY')
    },
    time (value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
    nullableTime (value) {
      if (!value || value == null) {
        return 'In progress...'
      }
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
    dayShortMonthYear (value) {
      return moment(value).format('DD MMM YYYY')
    }
  }
}

export default DateFormat



// WEBPACK FOOTER //
// ./src/mixins/DateFormat.js